import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { orders } from "../../../../../../../redux/orders/action";
import { selectOrdersListItems } from "../../../../../../../redux/orders/selector";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../../redux/library/selector";
import PageLoader from "../../../../../../../components/PageLoader";
import useWindowDimensions from "../../../../../../../hooks/useWindowsDimensions";
import Table from "../../../../../../../common/components/table-manager/v1.1/table";

const CustomerOrders = () => {
  const dispatch = useAppDispatch()
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectOrdersListItems)
  const libraryData = useSelector(selectListItems)
  const [pageSize, setPageSize] = useState(10);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'Message.InvoiceNumber', headerName: 'Invoice Number', searchField: 'InvoiceNumber', sortable: true, filter: true, filterType: 'text',
        isGeneratedPrintOrders: true
      },
      { field: 'Message.ShipmentPId', headerName: 'Order Id' },
      {
        field: 'Message.LogisticsOrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.LogisticsOrderStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      {
        field: 'Message.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      { field: 'Message.TransporterName', headerName: 'Transporter Name' },
      { field: 'Message.AgentName', headerName: 'Agent Name' },
      { field: 'Message.AgentPhoneNo', headerName: 'Agent Phone no' },
      { field: 'Message.TrackingNumber', headerName: 'Tracking Number', sortable: false, filter: true },
      { field: 'Message.DeliveryDateUtc', headerName: 'Schedule Date & Time', isDateValueFormat: true },
      { field: 'Message.CreatedOnUtc', headerName: 'Order Date', isDateValueFormat: true },

    ]);
  }
  const fetchOrders = () => {
    dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "InvoiceNumber",
        FieldText: "InvoiceNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }
  const handleReloadData = () => {
    fetchOrders()
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchOrders()
  }, [pageData, pageSize])

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const launchPrintInvoice = (data: any) => {
    console.log("datadata:", data)

    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      window.open(
        `${window.location.origin}/order/invoice/${data?.Message?.InvoiceNumber}`,
        '_blank',
        windowProps
      );
    }
  }
  const handleGeneratePrintOrdersInvoice = async (data: any) => {
    launchPrintInvoice(data);
  }
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <>

          <Table
            columnData={columnDefs}
            rowData={itemsData?.result?.items}
            onEdit={handleEdit}
            checkboxConfig={{
              allowMultiSelect: true,
              defaultSelectedIds: [],
              isDisabled: false,
              keyColumn: 'Id',
            }}
            onGeneratePrintOrderInvoice={handleGeneratePrintOrdersInvoice}
            additionButtons={additionButtons}
            onSearch={handleSearch}
            enableFilter={true}
            setPageData={setPageData}
            setPageSize={setPageSize}
            paginationData={itemsData?.result?.pagination}
            headingName="Orders" />

        </>
      }
    </>



  );
};

export default CustomerOrders;


